/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
window.addEventListener('load', function() {
  var search = window.location.search;
  if (search.indexOf('product=') === -1) return;
  
  var productMatch = search.match(/product=([^&]*)/);
  var urlMatch = search.match(/url=([^&]*)/);
  
  var product = productMatch ? decodeURIComponent(productMatch[1].replace(/\+/g, ' ')) : '';
  var productUrl = urlMatch ? decodeURIComponent(urlMatch[1].replace(/\+/g, ' ')) : '';
  
  if (product) {
    setTimeout(function() {
      var textarea = document.querySelector('textarea.bcontact_textarea');
      if (textarea) {
        textarea.value = 'Inquiry about: ' + product + '\nProduct URL: ' + productUrl;
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }, 3000);
  }
});
window.addEventListener('load', function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  
  var productTitle = document.querySelector('h1') ? document.querySelector('h1').innerText : '';
  var productUrl = window.location.href;
  
  var contactLinks = document.querySelectorAll('a[href*="/pages/contact-us"]');
  contactLinks.forEach(function(link) {
    link.href = '/pages/contact-us?product=' + encodeURIComponent(productTitle) + '&url=' + encodeURIComponent(productUrl);
  });
});
